<template>

  <div class="WechatUsers app-container">
    <el-card class="box-card">
      <header style="display: block; padding: 10px 0 40px 0;">
        <div style="float: left; display: flex;">
          <el-select
            v-model="accountListQuery.platform_id"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in platformSelectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <el-input v-model="accountListQuery.wechat_name" style="width: 200px; margin-right: 10px;" placeholder="微信名称" />
          <el-button
            type="primary"
            style="margin-right: 5px"
            icon="el-icon-search"
            @click="search"
          >搜索</el-button>
          <el-button
            type="primary"
            icon="el-icon-refresh"
            @click="reset"
          >重置</el-button>
        </div>
        <div style="float: right;">
          <el-button
            type="primary"
            style="float: right; margin-right: 20px;"
            @click="$refs.addAccountDialog.open()"
          >添加账号</el-button>
        </div>
      </header>
      <main>
        <el-table
          v-loading="loading"
          :data="tableData.list"
          style="width: 100%"
        >
          <el-table-column
            prop="account"
            label="账号名称"
            min-width="90"
          />
          <el-table-column
            prop="platform.name"
            label="平台"
            min-width="150"
          />
          <el-table-column
            prop="remark"
            label="备注"
            min-width="150"
          />
          <el-table-column
            align="center"
            label="异常"
            min-width="300"
          >
            <template scope="scope">
              <!-- <span class="overflow" :title="assemblyString(scope.row.errinfo)">{{ assemblyString(scope.row.errinfo) }}</span> -->
              <el-tag
                v-if="scope.row.errunhandle_count === 0"
                class="activew"
                type="success"
                @click="clicknormal(scope.row.id)"
              >正常</el-tag>
              <el-tag
                v-else
                class="activew"
                type="danger"
                @click="clickexception(scope.row.id)"
              >{{ `异常${scope.row.errunhandle_count}条` }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="账号状态"
            min-width="80"
          >
            <template scope="scope">
              <div style="position: relative; display: inline-block;">
                <el-switch
                  v-model="scope.row.status"
                  :width="60"
                  active-color="#13ce66"
                  inactive-color="rgb(191,191,191)"
                  :active-value="1"
                  :inactive-value="0"
                  @change="statusChange(scope.row)"
                />
                <div
                  v-if="scope.row.status === 1"
                  style="color: #fff;position: absolute;top: 2px;left: 7px;"
                >启用</div>
                <div
                  v-else
                  style="color: #fff;position: absolute;top: 2px;right: 7px;"
                >禁用</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            label="操作"
            min-width="180"
            align="center"
          >
            <template scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="$refs.addAccountDrawer.open(scope.row, accountListQuery.wechat_name)"
              >编辑</el-button>
              <el-button
                v-if="myIsSupertube"
                type="warning"
                size="mini"
                @click="$refs.modifyAccountDialog.open(scope.row)"
              >修改</el-button>
              <el-button v-if="myIsSupertube" type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </main>
      <el-dialog
        title="异常详情"
        :visible.sync="dialogTableVisible"
      >
        <exceptionInformation
          ref="errinform"
          @updatalist="updatalist"
        />
      </el-dialog>
      <pagination-right
        :total="tableData.total"
        :page-sizes="[accountListQuery.page_size]"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <add-account-drawer ref="addAccountDrawer" />
    <modifyAccountDialog
      ref="modifyAccountDialog"
      @emitModifyAccount="modifyAccount"
    />
    <add-account-dialog
      ref="addAccountDialog"
      :platform-select-list="platformSelectList"
      @emitAddAccount="addAccount"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getList, /* platformSelectList ,*/ changeStatus, addAccount, modifyPwd, deleteLi, isExceeded, getSearchLists } from '@/api/providerAccountManagement/WeChatAccountFans'
import AddAccountDialog from '@/views/report/WeChatAccountFans/components/addAccountDialog.vue'
import modifyAccountDialog from '@/views/report/WeChatAccountFans/components/modifyAccountDialog'
import addAccountDrawer from '@/views/report/WeChatAccountFans/components/addAccountDrawer.vue'
import exceptionInformation from '@/views/report/WeChatAccountFans/components/exceptionInformation.vue'
export default {
  name: 'BackConfig',
  components: {
    PaginationRight,
    addAccountDrawer,
    modifyAccountDialog,
    AddAccountDialog,
    exceptionInformation
  },
  data() {
    return {
      dialogTableVisible: false,
      platformSelectList: [], // 平台筛选列表
      accountListQuery: { // 列表数据
        platform_id: null,
        page: 1,
        page_size: 10,
        wechat_name: null
      },
      switchQuery: { // 更新公众号状态请求数据
        status: null
      },
      tableData: {}, // 表格数据
      data: {},
      loading: false, // 加载效果
      myIsSupertube: null,
      selectedEdits: null
    }
  },
  created() {
    this.getExceeded()
    this.getListData()
    this.getPlatformSelectList()
  },
  // activated() {
  //   this.getListData()
  // },
  methods: {
    // 获取列表数据
    getListData() {
      this.loading = true
      getList(this.accountListQuery).then(res => {
        this.tableData = res.data
        this.loading = false
      })
    },
    // 获取平台筛选列表
    getPlatformSelectList() {
      this.loading = true
      getSearchLists().then((res) => {
        this.platformSelectList = res.data.list
        this.loading = false
      })
      /*  platformSelectList().then(res => {
        this.platformSelectList = res.data.platform
        this.loading = false
      }) */
    },
    // 添加账号
    addAccount(data) {
      addAccount(data).then(res => {
        this.getListData()
      })
    },
    // modifyAccount修改密码
    modifyAccount(id, data, remark) {
      modifyPwd(id, { pwd: data, remark }).then(res => {
        this.getListData()
        this.getPlatformSelectList()
      })
    },
    // 状态改变
    statusChange(e) {
      this.switchQuery.status = e.status
      changeStatus(e.id, this.switchQuery).then(res => {
        this.getPlatformSelectList()
      })
    },
    // 分页
    fetchPageSize(e) {
      this.accountListQuery.page_size = e
      this.getListData()
    },
    fetchCurrentPage(e) {
      this.accountListQuery.page = e
      this.getListData()
    },
    // 搜索数据
    search() {
      this.accountListQuery.page = 1
      this.getListData()
    },
    // 重置搜索框
    reset() {
      this.accountListQuery = {
        platform_id: null,
        page: 1,
        page_size: 10,
        wechat_name: null
      }
      this.getListData()
    },
    // 点击正常弹窗
    clicknormal(id) {
      this.dialogTableVisible = true
      setTimeout(() => {
        this.$refs.errinform.open(id)
      }, 0)
    },
    // 点击异常请求
    clickexception(id) {
      this.dialogTableVisible = true
      setTimeout(() => {
        this.$refs.errinform.open(id)
      }, 0)
    },
    // 回传刷新数据
    updatalist() {
      this.getListData()
    },
    assemblyString(arr = []) {
      let text = ''
      for (let i = 0; i < arr.length; i++) {
        text += `${arr[i].type_str}:${arr[i].exception_info}\n\n `
      }
      return text
    },
    async deleteItem(row) {
      this.$confirm(`是否删除平台 ${row.platform.name}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await deleteLi(row.id)
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async getExceeded() {
      const data = await isExceeded()
      this.myIsSupertube = data.data.res
    }
  }
}
</script>

<style scoped lang="less">
.WechatUsers {
  min-width: 1200px;
  header {
    display: flex;
    margin-bottom: 20px;
    .el-select {
      margin-right: 20px;
    }
  }
}

.overflow {
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.activew {
  cursor: pointer;
}
</style>
